import { useTranslation } from 'react-i18next';
import FirstScreen from 'components/ui/firstTimeScreen/firstScreen';
import { ContentHeader } from 'components/ui/layout/ContentHeader';
import { DarwinFlex } from 'components/darwin-ui';
import { Image } from 'antd';
import DarwinTypography from 'components/darwin-ui/Typography';
import styles from './home.module.css';

export const Home = () => {
  const { t } = useTranslation();
  const selectedCompany = localStorage.getItem('selectedCompany') || null;

  if (!selectedCompany) return <FirstScreen />;

  return (
    <>
      <ContentHeader
        title={t('home-title')}
        onSaveTitle={t('users-page.users-list.create-new-user')}
      />
      <DarwinFlex vertical className={styles.homeContainer}>
        <DarwinFlex className={styles.homeSection} justify="space-between">
          <DarwinFlex vertical className={styles.textHomeSection}>
            <DarwinTypography.Text className={styles.label}>
              {t('home-label')}
            </DarwinTypography.Text>
            <DarwinTypography.Text className={styles.subtitle}>
              {t('home-subtitle')}
            </DarwinTypography.Text>
            <DarwinTypography.Text className={styles.text}>
              {t('home-description')}
            </DarwinTypography.Text>
            <DarwinTypography.Text
              className={styles.text}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              {t('home-page')}
              <DarwinTypography.Link
                href="https://darwinevolution.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('home-page-link')}
              </DarwinTypography.Link>
            </DarwinTypography.Text>
            <DarwinTypography.Text className={styles.text}>
              {t('home-manual')}
              <DarwinTypography.Link
                href="https://darwinevolution.notion.site/Manual-209952812774804ab892e87fc912e816"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('home-manual-link')}
              </DarwinTypography.Link>
              .
            </DarwinTypography.Text>
          </DarwinFlex>
          <DarwinFlex className={styles.darwinHomeLogo}>
            <Image height={180} preview={false} src="home-darwin.svg" />
          </DarwinFlex>
        </DarwinFlex>
        <DarwinFlex align="center" justify="space-between" gap={30}>
          <Image width={400} height={400} src="images/home/image1.webp" />
          <Image width={400} height={400} src="images/home/image2.webp" />
          <Image width={400} height={400} src="images/home/image3.webp" />
        </DarwinFlex>
      </DarwinFlex>
    </>
  );
};
